import Archive from '@mui/icons-material/Archive'
import Info from '@mui/icons-material/Info'
import Unarchive from '@mui/icons-material/Unarchive'

import { Installation, Role } from 'common-billing-server/types'
import { makeInstallationDetailsPath } from '../../routes/path'
import { FailedOperation } from '../common/hooks/hook-failed-operation'
import { ApiOperation, TableActionItem, TableActions } from '../common/TableActions'

interface Props {
    installation: Installation
    refreshTableFn?: () => void
    addFailedOperation: (failedOp: FailedOperation) => void
}

export const InstallationActions = ({ installation, addFailedOperation, refreshTableFn }: Props) => {
    const restoreAction: TableActionItem = {
        label: 'Restore installation',
        dataTestId: 'restore-installation',
        icon: <Unarchive />,
        onClick: makeRestoreInstallationOperation(installation.id),
        minimumAllowedRole: Role.licenseAdmin,
    }
    const archiveAction: TableActionItem = {
        label: 'Archive installation',
        dataTestId: 'delete-installation',
        icon: <Archive />,
        onClick: makeArchiveInstallationOperation(installation.id),
        minimumAllowedRole: installation.lastReportAt ? Role.admin : Role.licenseAdmin,
    }
    const actions = [
        {
            label: 'View',
            dataTestId: 'view-installation',
            icon: <Info />,
            onClick: makeInstallationDetailsPath({
                installationId: installation.id,
                customerId: installation.customer.id,
            }),
            minimumAllowedRole: Role.invoiceOnly,
        },
        installation.deleted ? restoreAction : archiveAction,
    ]
    return <TableActions actions={actions} refreshTableFn={refreshTableFn} addFailedOperation={addFailedOperation} />
}

export function makeArchiveInstallationOperation(installationId: string): ApiOperation {
    return {
        name: 'Archive installation',
        id: 'delete-installation',
        exec: async (api) => await api.deleteInstallation(installationId),
    }
}
export function makeRestoreInstallationOperation(installationId: string): ApiOperation {
    return {
        name: 'Restore installation',
        id: 'restore-installation',
        exec: async (api) => await api.restoreInstallation(installationId),
    }
}
